import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import Backend from "i18next-http-backend"

// Ensure a default language is stored before initializing i18n
try {
  if (typeof window !== "undefined") {
    const key = "i18nextLng"
    if (!window.localStorage.getItem(key)) {
      window.localStorage.setItem(key, "ua")
    }
  }
} catch (_) {
  // Ignore storage access (e.g., privacy mode)
}

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: ["en", "ua", "de", "fr", "it", "es", "pl"],
    debug: false,

    // Default namespace - will be used if no namespace is specified
    defaultNS: "common",

    // List all namespaces you want to load
    ns: ["common", "dashboard", "map", "spectrpro", "antimavic"],

    interpolation: {
      escapeValue: false,
    },

    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
  })

export default i18n
